import { Component, OnInit } from '@angular/core';
import { GeneralService } from '../general.service';
import { DataService } from '../data.service';
import {TranslateService} from '@ngx-translate/core';
import { ModalService } from '../modal.service';

declare var Hashes: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: [
    './login.component.scss'
  ]
})

export class LoginComponent implements OnInit {

  public logo = "";
  public errorText = "";
  public displayError = false;
  public Username = "";
  public Name = "";
  public Password = "";
  public loginDisabled = false;
  public languageSelected = "en";
  public showMockLogin = false;
  public showLogin = true;
  public showMockUsername = false;
  public showMockName = false;
  public mockExamId = 0;
  public showAssessorComplete = false;
  public showCandidateComplete = false;
  public fullName: string = "";
  public email: string = "";
  public showScreen: boolean = false;
  public isChromeBrowser = true;
  private suppressAutoLogin = false;

  constructor(
    public generalSvc: GeneralService,
    public dataSvc: DataService,
    public translate: TranslateService
  ) {
    // Set default values;
    this.logo = "";
    this.Username = "";
    this.Password = "";
    this.Name = "";
    this.isChromeBrowser = this.detectChromeBrowser();

  }

  private detectChromeBrowser(): boolean {
    var userAgent = navigator.userAgent || "";
    var isChrome = userAgent.indexOf("Chrome") > -1 || userAgent.indexOf("CriOS") > -1;
    var isNonChromeChromium = userAgent.indexOf("Edg") > -1
      || userAgent.indexOf("OPR") > -1
      || userAgent.indexOf("SamsungBrowser") > -1;

    return isChrome && !isNonChromeChromium;
  }

  async ngOnInit() {
    const configLoaded = await this.dataSvc.configReady;
    if (!configLoaded) {
      this.errorText = "Unable to load the exam configuration. Please refresh the page and try again.";
      this.displayError = true;
      this.showScreen = true;
      return;
    }

    if (this.dataSvc.kioskMode == true) {
      const params = new URLSearchParams(window.location.search);
      const kioskDownloadRequested = params.get('kiosk') == "1";
      const handoffToken = params.get('handoff');

      // The web application adds both handoff and kiosk when a browser needs
      // the kiosk download. The kiosk itself starts with kiosk=1 but has no
      // handoff token, so it must be allowed through to the login screen.
      if (kioskDownloadRequested && handoffToken) {
        window.location.href = "https://aclt.enetassess.com/DownloadKiosk.aspx";
        return;
      }
    }

    this.onLoad();

    var exisitingLangauge = localStorage.getItem("userslanguage");
    if(exisitingLangauge !== null && exisitingLangauge !== undefined && exisitingLangauge !== ""){
      this.dataSvc.changeLangauge(exisitingLangauge);      
    }
    else{
      this.translate.setDefaultLang("en");
      this.translate.use("en");
      exisitingLangauge = "en";
    }
    this.languageSelected = exisitingLangauge;  
    
  }

  goToFinishedKiosk() {
      window.location.href = this.dataSvc.exmUrl + "FinishedKiosk.aspx";
  }

  goToeNetAssess() {
      window.location.href = this.dataSvc.exmUrl;
  }

  changeLangauge(language){
    localStorage.setItem("userslanguage", language.toString());
    this.translate.setDefaultLang(language.toString());
    this.translate.use(language.toString());
    this.languageSelected = language.toString();  
  }

  checkEnetsecure(){
    if(!this.dataSvc.enetsecureMobile && !this.dataSvc.enetsecureWeb){
      var mobileSecure = this.generalSvc.getUrlParam("enetsecuremobile");
      var localStorageExamMethod = localStorage.getItem("examMethod");
      if(mobileSecure == "1" || localStorageExamMethod == "enetsecuremobile"){
        this.dataSvc.enetsecureMobile = true;
        this.dataSvc.enetsecureWeb = false;
        localStorage.setItem("examMethod", "enetsecuremobile");
        document.getElementById("version").innerHTML += " - eNetSecure";
      }
      else{
        var webSecure = this.generalSvc.getUrlParam("enetsecureweb");
        if(webSecure == "1" || localStorageExamMethod == "enetsecureweb"){
          this.dataSvc.enetsecureMobile = false;
          this.dataSvc.enetsecureWeb = true;
          localStorage.setItem("examMethod", "enetsecureweb");
          document.getElementById("version").innerHTML += " - eNetSecure";
        }
        else{
          this.dataSvc.enetsecureMobile = false;
          this.dataSvc.enetsecureWeb = false;
          localStorage.setItem("examMethod", "web");
        }
      }
    }  
    //console.log("securemobile = " + this.dataSvc.enetsecureMobile);  
    //console.log("secureweb = " + this.dataSvc.enetsecureWeb);  
  }

  

  onLoad() {

    var urlParams = new URLSearchParams(window.location.search);
    var username = urlParams.get('qs');
    var token = urlParams.get('a');
    var scheduleId = urlParams.get('sid');
    if(token !== "" && token !== null && token !== undefined){    
      if(username !== null && username !== undefined && username !== ""){
        this.dataSvc.initSSOLogin(username, token);
      }
    } 
    else if(scheduleId !== null && scheduleId !== "" && scheduleId !== undefined){    
      if(username !== null && username !== undefined && username !== ""){
        this.dataSvc.initBMSLogin(username, scheduleId);
      }
    }

    var errorParam = this.generalSvc.getUrlParam("err");
    var alreadyLoggedInParam = this.generalSvc.getUrlParam("es");
    var expiredParam = this.generalSvc.getUrlParam("expired");

    if (alreadyLoggedInParam == "1") {
      this.errorText = "You are already logged in on another device. Please close the other exam session before trying again.";
      this.displayError = true;
      this.suppressAutoLogin = true;
    }
    else if (expiredParam == "1") {
      this.errorText = "Your secure exam session has expired. Please log in again.";
      this.displayError = true;
      this.suppressAutoLogin = true;
    }
    else if (errorParam === 0) {
      this.errorText = "You entered incorrect login details.";
      this.displayError = true;
    }
    else if (errorParam == 1) {
      this.errorText = "Please login to eNetAssess.";
      this.displayError = true;
    }
    else {
      this.displayError = false;
    }
    if(this.checkExmLogin() == false)
    {
      this.checkEnetsecure();
      this.displayLoginOptions();
    }

    setTimeout(() => {
      this.showScreen = true;
    }, 1000);
  }

  checkExmLogin(){
    var handoffToken = this.generalSvc.getUrlParam("handoff");
    if(handoffToken !== null && handoffToken !== undefined && handoffToken !== ""){
      this.dataSvc.initHandoffLogin(handoffToken.toString());
      this.showLogin = false;
      this.showMockLogin = false;
      return true;
    }

    return false;
  }

  displayLoginOptions(){
    var mockParam = this.generalSvc.getUrlParam("mock");
    if(mockParam == 1){
      this.showLogin = false;
      this.showMockLogin = true;
      var mockIdParam = this.generalSvc.getUrlParam("mid") as number;
      if(mockIdParam !== null && mockIdParam !== undefined){
        this.mockExamId = mockIdParam;
        var mockUsernameParam = this.generalSvc.getUrlParam("mu");
        if(mockUsernameParam !== null && mockUsernameParam !== undefined && mockUsernameParam === "1"){
          this.showMockUsername = true;
        }
        else{
          this.showMockUsername = false;
        }
        var mockUsersNameParam = this.generalSvc.getUrlParam("mn");
        if(mockUsersNameParam !== null && mockUsersNameParam !== undefined && mockUsersNameParam === "1"){
          this.showMockName = true;
        }
        else{
          this.showMockName = false;
        }
      }
    }
    else{
      this.showMockLogin = false;
      this.checkAssessorLogin();
      this.checkAnonymousCandidateLogin();
    }
  }

  getMembership(pass, salt) {
      var SHA1 = new Hashes.SHA1().b64(pass);
      var SHA1ws = new Hashes.SHA1().b64_hmac(pass, salt);
      return SHA1ws;
  }

  checkLogin() {
    if (this.Username.indexOf("demo") > -1)
      this.Username = "demo";

    this.dataSvc.initLogin(this.Username, this.Password);
  }

  checkMockLogin() {
    if (this.Username === "")
      this.Username = "mockuser";

      if (this.Name === "")
        this.Name = "Mock User";
      this.Password = "12345"

    this.dataSvc.initMockLogin(this.Username, this.Password, this.mockExamId, this.Name );
  }

  checkAssessorLogin(){
    var assessorParam = this.generalSvc.getUrlParam("al");
    if(assessorParam == "1"){
        this.showLogin = false;
        this.showMockLogin = false;
        this.showAssessorComplete = true;
        //console.log("send complete");
        window.parent.postMessage('exam-completed', '*');
    }
      else{
      var assessorAuthenticated = this.generalSvc.getUrlParam("aauth");
      if(assessorAuthenticated !== undefined && assessorAuthenticated !== null && assessorAuthenticated !== ""){
        this.dataSvc.initAssessorLogin(assessorAuthenticated);
      }
    }
  }

  checkAnonymousCandidateLogin(){
    var acandidateParam = this.generalSvc.getUrlParam("cl");
    if(acandidateParam == "1"){
        this.showLogin = false;
        this.showMockLogin = false;
        this.showCandidateComplete = true;
    }
      else{
      var candidateAuthenticated = this.generalSvc.getUrlParam("cauth");
      if(candidateAuthenticated !== undefined && candidateAuthenticated !== null && candidateAuthenticated !== ""){
        this.dataSvc.initAnonymousCandidateLogin(candidateAuthenticated);
      }
    }
  }

  submitTrialLogin() {
    this.loginDisabled = true;
    this.dataSvc.submitTrialLogin(this.fullName, this.email);

    setTimeout(() => {
      this.loginDisabled = false;
    }, 2500);
  }

  processLogin(query) {
    var scQuery = query.replace(/\+/g, "###plus###");
  }

  submitLogin() {
    this.loginDisabled = true;
    this.checkLogin();

    setTimeout(() => {
      this.loginDisabled = false;
    }, 2500);
  }

  submitMockLogin() {
    this.loginDisabled = true;
    this.checkMockLogin();

    setTimeout(() => {
      this.loginDisabled = false;
    }, 2500);
  }
}
